import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { CaptureConsole } from '@sentry/integrations';

window.setSentryUrlHash = function (organization_slug) {
  Sentry.setTag("organization", organization_slug);
}

Sentry.init({
  dsn: 'https://9baa4e393db847e197a673dd1b85be4b@o688802.ingest.sentry.io/6761874',
  environment: window.gon?.environment ? window.gon.environment : 'unknown',
  release: 'smaply@1.0.0',
  integrations: [
    new BrowserTracing(),
    new CaptureConsole({
      levels: ['error']
    })
  ],

  // Choose a sampling rate with the goal of finding a balance between
  // performance and volume concerns with data accuracy. You don't want to
  // collect too much data, but you want to collect sufficient data from
  // which to draw meaningful conclusions. If you’re not sure what rate to
  // choose, start with a low value and gradually increase it as you learn
  // more about your traffic patterns and volume.
  // https://docs.sentry.io/platforms/javascript/configuration/sampling/#sampling-transaction-events
  tracesSampleRate: 0.1,
});
